<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink, RouterView } from 'vue-router'
import { APP_VERSION, PRODUCT_NAME } from '@bf/domain'
import { runtimeConfig } from '../platform/runtime'
import { useShowroomStore } from '../store/showroom'

const store = useShowroomStore()

const topNavItems = [
  { label: '首页', to: { name: 'home' } },
  { label: '机柜方案', to: { name: 'cabinet-generator' } },
  { label: '控制器与 I/O', to: { name: 'controller-io' } },
  { label: '末端设备', to: { name: 'terminal-devices' } },
  {
    label: '软件风格',
    to: { name: 'catalog', params: { section: 'software' } }
  },
  {
    label: '应用案例',
    to: { name: 'catalog', params: { section: 'cases' } }
  }
]

const railNavItems = [
  { label: '总览', icon: '▤', to: { name: 'home' } },
  { label: '机柜', icon: '▣', to: { name: 'cabinet-generator' } },
  { label: 'CPU/IO', icon: '▦', to: { name: 'controller-io' } },
  { label: '末端', icon: '◎', to: { name: 'terminal-devices' } },
  {
    label: '风格',
    icon: '◫',
    to: { name: 'catalog', params: { section: 'software' } }
  },
  {
    label: '案例',
    icon: '□',
    to: { name: 'catalog', params: { section: 'cases' } }
  }
]

const basketCount = computed(() => store.state.draft?.items.length ?? 0)
</script>

<template>
  <div :class="['reference-shell', { 'mobile-public-shell': runtimeConfig.mode === 'mobile-public' }]">
    <header class="reference-header">
      <RouterLink class="reference-brand" :to="{ name: 'home' }">
        <span class="reference-brand-mark">B</span>
        <span>
          <strong>{{ PRODUCT_NAME }}</strong>
          <small>BUILDING AUTOMATION SHOWROOM</small>
        </span>
      </RouterLink>

      <nav class="reference-top-nav" aria-label="顶部主导航">
        <RouterLink v-for="item in topNavItems" :key="item.label" :to="item.to">
          {{ item.label }}
        </RouterLink>
      </nav>

      <div class="reference-header-actions">
        <RouterLink class="offline-pill" :to="{ name: 'status' }">
          <i aria-hidden="true"></i>
          {{ runtimeConfig.label }}
        </RouterLink>
        <RouterLink class="solution-cta" :to="{ name: 'basket' }">
          生成项目方案
          <b v-if="basketCount">{{ basketCount }}</b>
        </RouterLink>
      </div>
    </header>

    <aside class="reference-rail">
      <nav aria-label="快捷导航">
        <RouterLink
          v-for="item in railNavItems"
          :key="item.label"
          :to="item.to"
        >
          <span>{{ item.icon }}</span>
          <small>{{ item.label }}</small>
        </RouterLink>
      </nav>
      <div class="rail-version">
        <span>v{{ APP_VERSION }}</span>
        <small>{{ store.state.manifest?.contentVersion }}</small>
      </div>
    </aside>

    <main class="reference-main">
      <RouterView />
    </main>

    <div v-if="store.state.notice" class="toast" role="status">
      <span>{{ store.state.notice }}</span>
      <button type="button" aria-label="关闭提示" @click="store.dismissNotice">
        ×
      </button>
    </div>

    <nav class="reference-bottom-nav" aria-label="手机端主导航">
      <RouterLink
        v-for="item in railNavItems"
        :key="item.label"
        :to="item.to"
      >
        <span>{{ item.icon }}</span>
        <small>{{ item.label }}</small>
      </RouterLink>
    </nav>
  </div>
</template>
